export default __webpack_public_path__ + "static/media/Guitars_07.22641f97.png";